export interface EntityBase {
  id: number | string;
  [x: string]: any;
}

export interface FilteredPagedModel {
  page: number;
  pageSize: number;
  searchTerm: string;
  sortFieldName: string;
  descending: boolean;
  [x: string]: any;
}

export interface FilteredPagedQueryResult<T> {
  page: number;
  pageSize: number;
  totalCount: number;
  data: Array<T>;
  [x: string]: any;
}

export interface EntityCommonInfoModel {
  totalRecords: number;
  lastCreateAt: string;
  lastUpdateAt: string;
}

export interface CommonCollectorModel {
  symbols: string[];
}

export interface CommonMergeModel {
  mainId?: number;
  fakeIds: number[];
}

export interface CommonMultiDeleteModel {
  ids: number[];
}
export interface EntityConfirmModel {
  id: number;
  confirmed: boolean;
}

export interface EntityReplaceModel {
  id?: number;
  replaceId?: number;
}

export enum ActiveFilterEnum {
  All,
  Active,
  Inactive,
}

export enum ValidFilterEnum {
  All,
  Valid,
  Invalid,
}

export interface CommonEntityActiveSwitch {
  id: number | string;
  isActive: boolean;
}

export interface CommonRejectionModel {
  id: number | string;
  rejectionReason: string;
}

export interface ApiMessageResponse {
  message: string;
}

// ----------- Pagination ---------------------

export enum SortDirection {
  Asc = 0,
  Desc = 1,
}

export interface PaginationRequest {
  pageNumber: number;
  pageSize: number;

  sortBy?: string;
  sortDirection?: SortDirection;
}

export interface PaginationMetadata {
  pageNumber: number;
  pageSize: number;
  totalCount: number;
  totalPages: number;
  hasPreviousPage: boolean;
  hasNextPage: boolean;
}

export interface PagedResponse<T> {
  items: T[];
  pagination: PaginationMetadata;
}
